<template>
  <div id="home" class="home">
    <div class="jumbo-header position-relative">
        <video class="fullscreen-video" width="100%" height="auto" autoplay loop muted playsinline>
            <source src="../assets/video/swimming_pool.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <div class="position-absolute ds-image-overlay dark-overlay flex-column" v-observer>
            <div id="header-matrix" class="matrix-element" >
                <div class="matrix-inner">
                    <div class="slogan-wrapper">
                        <h1 class="title-phone">
                            <!--<span class="s-base s-base-start s1">{{webData.title}} </span>-->
                            <!--<span class="s-base s-base-start s1" style="display:block" v-for="(word, index) in getWords(webData.title)" :key="index" v-html="wordWithLineBreak(word)"></span>-->
                            <span class="s-base s-base-start s1" v-for="(word, index) in getFirstWords(webData.title)" :key="index">{{ word }}</span>
                            <span class="s-base s-base-start-last-words s1" v-for="(word, index) in getLastWords(webData.title)" :key="index">{{ word }}</span>
                        </h1>
                    </div>
                </div>
            </div>
        </div>
      <!--<div class="scroll-more-overlay">
          <p class="house-title">{{webData.houseTitle}}</p>
      </div>-->
    </div>
    <div class="video-container">
        <video class="fullscreen-video" autoplay loop muted playsinline>
            <source src="../assets/video/pool_inside.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>

        <div class="video-text">
            <p class="text-color">{{ webData.videoQuote }}</p>
            <p class="text-color author-name">- Tim O'Brien -</p>
        </div>
    </div>
      <!--<div class="h3-container">
          <div id="module-one" class="module-wrapper" style="transition: all 400ms ease;" v-observer>
              <div class="p-5-wrapper pb-0">
                  <div class="flex-wrapper">
                      <div class="img-wrapper f-item-50 row-item col-item" @click="viewTransition('accommodation')" style="max-width: 730px; cursor: pointer;">
                          <img src="../assets/static/Katarina_home_01.jpg" alt="Katarina di Maladel" class="img-filter-dark-shadow">
                          <div class="position-absolute ds-image-overlay yellow-light">
                              <h3>{{webData.acc}}</h3>
                          </div>
                      </div>
                      <div class="img-wrapper f-item-50" @click="viewTransition('services')" style="max-width: 730px; cursor: pointer;">
                          <img src="../assets/static/Katarina_home_02.jpg" alt="Katarina di Maladel" class="img-filter-dark-shadow">
                          <div class="position-absolute ds-image-overlay purple-light">
                              <h3>{{webData.ft}}</h3>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>-->
        <div class="tailored-section">
        <br><br>
        <h2 class="tailored-for-you">{{ webData.tailoredTitle }}</h2>
            <div class="image-container">
                <div class="image-box img-box-left" v-observer>
                    <div class="overlay" style="margin-bottom: 50px;">
                        <h3 class="tailored-header">{{webData.tailoredSection.t1}}</h3>
                        <p class="tailored-text">{{webData.tailoredSection.p1}}</p>
                    </div>
                    <div class="overlay" style="margin-bottom: 50px;">
                        <h3 class="tailored-header">{{webData.tailoredSection.t2}}</h3>
                        <p class="tailored-text">{{webData.tailoredSection.p2}}</p>
                    </div>
                    <div class="overlay" style="margin-bottom: 50px;">
                        <h3 class="tailored-header">{{webData.tailoredSection.t3}}</h3>
                        <p class="tailored-text">{{webData.tailoredSection.p3}}</p>
                    </div>
                </div>
                <div class="image-box img-box-right" v-observer>
                    <video class="img3-mod" autoplay muted playsinline>
                        <source src="../assets/video/katarina_opening_scene.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
      <!--
      <div class="h3-container">
          <div id="module-two" class="module-wrapper mobile-wrapper-none" v-observer>
              <div class="h3-container">
                  <div class="p-5-wrapper position-relative pt-0 pb-0">
                      <div class="position-absolute alt-line-wrapper">
                          <small class="alt-title mr-2">{{webData.ft}}</small>
                          <div class="alt-line"></div>
                      </div>
                      <div class="flex-wrapper overflow-hidden">
                          <div class="f-item-50 text-box-left">
                              <p class="text-justify">{{webData.p1}}</p>
                              <div class="spacer-mm"></div>
                              <a @click="$router.replace('services')" style="cursor: pointer; color: #000000;"><i>{{webData.discoverMore}} &#8594;</i></a>
                          </div>
                          <div class="img-wrapper f-item-50 text-right">
                              <img src="../assets/static/Katarina_home_03.jpg" alt="Katarina di Maladel">
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      -->
    <div class="video-container">
        <video class="smaller-video" autoplay muted loop playsinline v-on:mouseover="startVideo" v-on:mouseleave="pauseVideo">
            <source src="../assets/video/living_room_loop.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>

        <div class="video-text-bottom-left" v-observer>
            <p class="video-text-color" style="text-align:left">{{webData.diningRoomVideo}}</p>
        </div>
    </div>

    <br><br>
    <div class="video-container" style="margin-bottom: -6px;">
        <video class="smaller-video" autoplay muted loop playsinline>
            <source src="../assets/video/pool.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>

        <div class="video-text-top-right" style="background-color: #869ac271 !important;" v-observer>
            <p class="video-text-color phone-text-billiard" style="text-align:right">{{ webData.billiardVideo }}</p>
        </div>
    </div>
    <div style="background-color: rgb(239,235,229)">
        <br><br><h1 class="section-title dimensions-luxury" v-observer>{{ webData.doubleVideoTitle }}</h1>
        <div class="split-image-section">
            <div class="left-half" v-observer>
                    <video class="left-video" autoplay muted playsinline>
                        <source src="../assets/video/sofa.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                <div class="content-with-border content-margin">
                    <h3 style="color:black;">{{ webData.twoVideoSection.t2 }}</h3>
                    <p style="color:black;font-weight:500;">{{ webData.twoVideoSection.p2 }}</p>
                </div>
            </div>
            <div class="right-half" v-observer>
                <div class="content-with-border">
                    <h3 style="color:black;">{{ webData.twoVideoSection.t1 }}</h3>
                    <p style="color:black;font-weight:500;">{{ webData.twoVideoSection.p1 }}</p>
                </div>
                    <video class="right-video" autoplay muted playsinline>
                        <source src="../assets/video/balcony.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
            </div>
        </div>
    </div>
    <div class="video-container">
        
        <video id="myVideo" style="filter: brightness(100%)" class="fullscreen-video" autoplay muted playsinline loop>
            <source src="../assets/video/lamp_outside.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <div class="nav-video-text-top-right" v-observer>
            <p class="video-text-color videonav-text" style="text-align:right">{{ webData.lampVideo.desc }}</p>
        </div>
        <div class="video-navigation">
            <div class="video-nav-text">{{ webData.lampVideo.p1 }}</div>
            <div class="video-nav-text">{{ webData.lampVideo.p2 }}</div>
            <div class="video-nav-text">{{ webData.lampVideo.p3 }}</div>
            <div class="video-nav-text">{{ webData.lampVideo.p4 }}</div>
            <div class="video-nav-text">{{ webData.lampVideo.p5 }}</div>
        </div>
    </div>
    <div style="background-color: rgb(239,235,229)">
        <h2 class="section-title-yt">{{ webData.ytVideoTitle }}</h2>
        <div class="yt-video-container">
            <iframe width="1200" height="675" style="overflow: hidden; width:100%;" src="https://www.youtube.com/embed/chOqz62-GSA" frameborder="0" allowfullscreen></iframe>
        </div>
    </div>
    <div class="book-now-section">
        <!--<img src="../assets/images/katarina1.jpg" alt="Luxury Vacation" class="book-now-image">-->
        <div class="book-now-image">
        <div class="book-now-content" v-observer>
            <h1 style="font-size:41px">{{ webData.bookTitle }}</h1>
        </div>
        <router-link to="/book" class="book-now-button" v-observer>{{ webData.bookNow }}</router-link></div>
    </div>
      <!--<div class="primary-background" style="width: 100%">
          <div class="h3-container">
              <div id="module-three" class="module-wrapper" v-observer>
                  <div class="flex-wrapper">
                      <div v-for="item in galleryList" :key="item.id" class="ds-card row-item col-item">
                          <img :src="imgDisplay(item.src)" :alt="item.alt" class="ds-card-blur">
                          <div class="position-absolute ds-card-overlay dim-overlay">
                              <div class="ds-title-box">
                                  <h4>{{item.room}}</h4>
                              </div>
                              <div class="ds-link-box">
                                  <router-link to="/gallery" ><i>{{webData.clickForMore}}</i><p>&#8594;</p></router-link>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div id="module-four" class="secondary-background">
          <div class="h3-container module-wrapper mobile-wrapper-none" v-observer>
              <div class="p-5-wrapper pt-0 pb-0">
                  <div class="position-relative overflow-hidden img-filter-dark-shadow">
                      <transition name="slideInRight" mode="out-in">
                          <img :key="sliderImage.id" :src="sliderImage.src" :alt="sliderImage.alt" class="wide-img-module">
                      </transition>
                      <div class="position-absolute light-overlay overlay-text">
                          <h3>{{webData.t1}}</h3>
                          <div class="spacer-xl"></div>
                          <a @click="$router.replace('book')" style="cursor: pointer;"><i>{{webData.checkAva}} &#8594;</i></a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="module-wrapper mobile-wrapper-none" style="background-color: #f7f7f7;">
          <div class="h3-container">
              <div class="overflow-hidden" v-observer>
                  <h2 class="position-relative m-title">{{webData.t2}}</h2>
                  <div class="spacer-mm"></div>
                  <iframe class="maps-iframe" style="border:0; width: 100%;" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5600.804472003227!2d13.541053497333397!3d45.421392392348785!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x13fd7facac1c4096!2sStancija%20Katarina%20di%20Maladel!5e0!3m2!1shr!2shr!4v1612453707832!5m2!1shr!2shr&key=AIzaSyBoWHWhW0hPM4BbdGdgtSA3II4H7zBPJpE" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
              </div>
          </div>
      </div>
      <div class="module-eight-bg">
          <div class="p-5 flex-wrapper align-items-end" style="width: 100%; height: 100%; flex-direction: row!important;">
              <button class="book-btn cta-btn"><span class="position-relative"><router-link to="gallery">{{webData.visitGal}}</router-link></span></button>
          </div>
      </div>-->
    <Footer :web-data-global="webData" :key="webData.key"></Footer>
  </div>
</template>

<script>

import Footer from "@/modules/Footer";

import sliderS01 from '../assets/static/Katarina_home_10.jpg'
import sliderS02 from '../assets/static/Katarina_home_11.jpg'
import sliderS03 from '../assets/static/Katarina_home_12.jpg'
import sliderS04 from '../assets/static/Katarina_home_13.jpg'

export default {
  name: 'Home',
    props: {
        webDataGlobal: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            elA: '',
            elCliEnter: '',
            galleryList: [
                {id: 1, alt: 'Katarina di Maladel', src: 'Katarina_home_04.jpg', room: 'Living Room'},
                {id: 2, alt: 'Katarina di Maladel', src: 'Katarina_home_05.jpg', room: 'Bathroom'},
                {id: 3, alt: 'Katarina di Maladel', src: 'Katarina_home_06.jpg', room: 'Kitchen'},
                {id: 4, alt: 'Katarina di Maladel', src: 'Katarina_home_07.jpg', room: 'Bedroom'},
                {id: 5, alt: 'Katarina di Maladel', src: 'Katarina_entertainment.jpg', room: 'Entertainment'},
                {id: 6, alt: 'Katarina di Maladel', src: 'Katarina_outside_5.jpg', room: 'Outside'}
            ],
            gallerySlider: [
                {id: 1, alt: 'Katarina di Maladel', src: sliderS01},
                {id: 2, alt: 'Katarina di Maladel', src: sliderS02},
                {id: 3, alt: 'Katarina di Maladel', src: sliderS03},
                {id: 4, alt: 'Katarina di Maladel', src: sliderS04},
            ],
            sliderImage: {
                id: 1,
                alt: 'Katarina di Maladel',
                src: sliderS01
            },
            titleLoading: false,
            webData: {}
        }
    },
    created () {
        this.webData = this.webDataGlobal.home;
        this.$emit('set-nav-state', true);
    },
    mounted () {
        this.elA = document.querySelector(".img-wrapper");
        this.elCliEnter = document.querySelector("#cli-enter");
        this.settingUpTitle();
        this.infiniteSlider();
    },
    methods: {
        getWords(title) {
            return title.split(' ');
        },
        getFirstWords(title) {
            return title.split(' ').slice(0, 2);
        },
        getLastWords(title) {
            const words = title.split(' ');
            return words.slice(words.length - 2, words.length);
        },
        wordWithLineBreak(title) {
            return title.replace('<br>');
        },
        isFunction(functionToCheck) {
          let getType = {};
          return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
        },
        showDetails(category) {
            // Implementirajte logiku za prikaz detalja o kategoriji
            console.log(`Details for category: ${category}`);
        },
        startVideo() {
        const video = this.$refs.myVideo;

        // Provjeri jesu li koordinate miša unutar granica videa
        const videoRect = video.getBoundingClientRect();
        const mouseX = event.clientX;
        const mouseY = event.clientY;

        if (
            mouseX >= videoRect.left &&
            mouseX <= videoRect.right &&
            mouseY >= videoRect.top &&
            mouseY <= videoRect.bottom
        ) {
            video.play();
        }
        },
        pauseVideo() {
        this.$refs.myVideo.pause();
        },
      async getImageSource () {
          let c = await this.currImg.src();
          this.currImg.src = c.default;
          this.currImg.src = '';
          this.currImg.src = c.default;
          this.isReadyImg = true;
          this.$store.commit('setImageSource', this.currImg.src);
      },
        async filterImages (blockNumber) {
          if (blockNumber === 1) {
              this.isFilterActive = false;
              this.currIndex = await this.$store.dispatch('getIndexOfImage', this.currImg);
          } else {
              this.isReadyImg = this.nextImageState = false;
              this.isFilterActive = true;
              this.$store.commit('setGalleryFilterNumber', blockNumber);
              this.filteredImages = await this.$store.getters.getGalleryFilter;
              this.currImg = this.filteredImages[0];
              if (this.isFunction(this.currImg.src))  {
                  let index = await this.$store.dispatch('getIndexOfImage', this.currImg);
                  this.$store.commit('setGalleryIndex', index);
                  await this.getImageSource();
              }
              else this.isReadyImg = true;
          }
          let e = event.target;
          this.setActiveFilter(e);
        },
        
        
        settingUpTitle () {
            this.titleLoading = this.$store.getters.getTitleLoadingState;
            if (!this.titleLoading) {
                setTimeout(() => {
                    this.settingUpTitle();
                }, 400)
            }
        },
        infiniteSlider () {
            let id = this.sliderImage.id;
            if (id === 4)    this.sliderImage = this.gallerySlider[0];
            else  this.sliderImage = this.gallerySlider[id];
            setTimeout(() => {
                this.infiniteSlider();
            }, 8000)
        },
        viewTransition (location) {
            this.$router.replace(location);
        },
        imgDisplay (img) {
            return require(`../assets/static/${img}`)
        }
    },
  components: {
    Footer
  }
}
</script>

<style>
body {
    scroll-behavior:initial !important;
}
.title-phone 
{
    display: contents;
}
.primary-background {
    background-color: rgba(225, 216, 191, 0.5);
}
.secondary-background {
    background-color: #9fa4c4;
}
.background-half-wrapper {
    top: 0;
    width: 70%;
    height: calc(100% - 6rem);
    background-color: rgba(225, 216, 191, 0.5);
    z-index: 0;
}

.slogan-wrapper {
    background-color: rgba(0, 0, 0, 0.507);
}

.h3-container {
    width: 100%;
    max-width: 1452px;
    margin: 0 auto;
}
.p-5-wrapper {
    padding: 3rem;
}
.p-6-wrapper {
    padding: 5rem;
}
.p-7-wrapper {
    padding: 8rem;
}
.flex-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}
.wrap-border {
    border: 1px solid #98D37C;
}
.wrap-border.right {
    padding: 1.5rem 5rem 1.5rem 0;
}
.wrap-border.left {
    padding: 1.5rem 0 1.5rem 5rem;
}
.cta-btn {
    transform: none!important;
}
.cta-btn span {
    width: 320px;
    height: 60px;
    padding-top: 18px;
}
/*___________________________________________*/
/*                  ALT LINE                */
.alt-line-wrapper {
    top: 0;
    left: 0;
    width: 59%;
    text-align: right;
    z-index: 1;
    padding-top: 2.5rem;
}
.alt-title, .alt-line {
    display: inline-block;
}
.alt-title.green {
    color: #98D37C;
}
.text-box-left.green, .text-box-right.green, a.green {
    color: #98D37C;
}
.alt-line.green {
    background-color: #98D37C;
}
.alt-title {
    color: rgb(0, 0, 0);
    text-transform: uppercase;
}
.alt-line {
    height: 1px;
    width: 150px;
    border-radius: 5px;
    vertical-align: middle;
    background-color: rgb(0, 0, 0);
}
/*___________________________________________*/
/*                   MODULE ONE             */
#module-one .img-wrapper {
    max-width: 730px;
}
#module-one .img-wrapper img {
    width: 730px;
    height: auto;
    transition: all 8000ms ease-out;
}
.img-wrapper {
    position: relative;
    overflow: hidden;
}
#module-one .img-wrapper:hover img {
    transform: scale(1.5);
}
/*___________________________________________*/
/*                  MODULE THREE            */

#module-three .flex-wrapper {
    flex-wrap: wrap;
    flex-direction: row!important;
}
.ds-card {
    position: relative;
    margin-right: 12px !important;
    overflow: hidden;
}
.ds-card-blur {
    -webkit-filter: blur(4px);
    filter: blur(4px);
    -webkit-transition: .3s ease-in-out;
    transition: .3s ease-in-out;
}
.ds-image-overlay, .ds-card-overlay {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    color: #ffffff;
}
.ds-image-overlay {
    align-items: center;
    justify-content: center;
}
.ds-card-overlay {
    text-align: center;
    flex-direction: column;
}

.ds-card-overlay p {
    color: #ffffff;
    font-size: 22px;
    text-decoration: none;
    transform: rotateZ(90deg);
}
.ds-title-box, .ds-link-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 50%;
}
.ds-link-box a {
    color: #ffffff;
    margin-bottom: -100px;
    transition: margin-bottom 300ms;
    position: relative;
    z-index: 1;
}
.ds-link-box:before {
    content: '';
    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 0;
    transition: opacity 300ms;
}
.ds-card:hover .ds-card-blur {
    -webkit-filter: blur(0);
    filter: blur(0);
}
.ds-card:hover .ds-card-overlay .ds-link-box:before {
    opacity: 1;
}
.ds-card:hover .ds-card-overlay .ds-link-box a {
    margin-bottom: 0;
}
/*___________________________________________*/
/*                  MODULE FIVE             */
.v-overflow {
    overflow: visible;
}
/*___________________________________________*/
/*                 MODULE SEVEN             */
#module-seven .background-half-wrapper {
    right: 0;
}
/*___________________________________________*/
/*                 MODULE EIGHT             */
#module-eight .background-half-wrapper {
    left: 0;
}
/************************************************/
.f-item-50 {
    flex: 50%;
}
@media (min-width: 1220px) {
    #module-three.module-wrapper {
        padding: 3rem 8rem;
    }
    .text-box-left {
        padding-right: 150px;
    }
    .text-box-right {
        padding-left: 150px;
    }
}





@media (min-width: 992px) {
    .jumbo-header .ds-image-overlay .matrix-element {
        padding: 150px 100px 200px;
    }
    .overlay-text {
        padding: 15% 0 0 150px;
    }
    .text-box-left {
        padding-right: 120px;
    }
    .text-box-right {
        padding-left: 120px;
    }
    .slogan-wrapper {
        width: -moz-max-content;
        width: max-content;
        margin: 0 auto;
        padding: 20px 65px 20px 65px;
    }
    .text-block {
        padding: 0 3rem;
    }
}

@media (min-width: 1080px) {
    h1 span.s-base-start {
        font-size:35px;
    }
    h1 span.s-base-start-last-words {
        font-size: 35px;
    }
    .slogan-wrapper {
        padding: 40px 65px 40px 65px;
    }
    .img-box-right {
        margin-right: 70px !important;
    }
}

@media (max-width: 1080px) {
    .jumbo-header .ds-image-overlay .matrix-element {
        padding: 0px 100px 200px !important;
    }
}

@media only screen and (min-width: 1000px) and (max-width: 1380px) {
    .overlay {
        padding: 30px;
        width: 300px !important;
    }
    .img-box-left {
        width: 35%;
    }
    .img-box-right {
        width: 65%;
    }
}

@media only screen and (min-width: 769px) and (max-width: 1600px) {
    .jumbo-header .ds-image-overlay .matrix-element {
        padding: 150px 100px 200px !important;
    }
    h1 span.s-base-start {
        font-size: 35px;
    }
    h1 span.s-base-start-last-words {
        font-size: 35px;
    }
    .slogan-wrapper {
        padding: 40px 65px 40px 65px;
    }
    
}

@media (max-width: 992px) {
    .p-5-wrapper {
        padding: 0!important;
    }
    .p-7-wrapper {
        padding: 0!important;
    }
    .jumbo-header .ds-image-overlay .matrix-element {
        padding: 150px 30px 200px;
    }
    .overlay-text {
        padding: 11% 0 0 50px;
    }
    .text-box-left {
        padding-right: 60px;
    }
    .text-box-right {
        padding-left: 60px;
    }
    .slogan-wrapper {
        width: auto;
        padding: 40px 30px 40px 30px;
    }
    .text-block {
        padding: 0 1.8rem;
    }
}
    .fullscreen-video {
        width: 100%;
        height: 100vh;
        object-fit: cover; 
        filter: brightness(60%);
        display: flex;
    }
    .smaller-video {
        height:700px;
        width: 100%;
        object-fit: cover; 
    }
    .video-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: white;
        font-size: 2rem;
    }
    .video-text-bottom-left {
        position: absolute;
        bottom: 0;
        left: 0;
        transform: none;
        text-align: center;
        font-size: 2rem;
        width: 100%; 
        padding: 65px;
        background-color: #47413d81;
        margin-bottom: 80px;
    }
    .video-text-top-right {
        position: absolute;
        top: 0px; 
        text-align: center;
        font-size: 2rem;
        width: 100%;
        padding: 65px;
        background-color: rgba(255, 255, 255, 0.3);
        margin-top: 80px;
    }
    .nav-video-text-top-right {
        position: absolute;
        top: 0px; 
        text-align: center;
        font-size: 2rem;
        width: 100%;
        padding: 65px;
        margin-top: 80px;
    }

    .text-color {
        color: #E1C267;
    }
    .video-text-color {
        color: white;
    }
    .video-container {
        position: relative;
        overflow: hidden;
    }

    /* New dimensions of luxury... */

    .section-title {
        color: black;
        margin-left:30px;
    }

    .section-title-yt {
        color: black;
        margin-left:30px;
        padding-top: 50px;
        font-size: 41px;
    }

    .split-image-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .left-half,
    .right-half {
        flex: 1;
        padding: 20px;
    }

    .left-half img {
        width: 100%;
        height: auto;
        display: block;
        margin-bottom: 20px;
    }
    .right-half img {
        width: 100%;
        height: auto;
        display: block;
        margin-top: 20px;
    }

    .content-with-border {
        border: 2px solid black;
        padding: 15px;
        width: 70%;
        margin: auto;
    }
    .left-video, .right-video {
        height: 400px;
        width: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        filter: brightness(60%);
    }

    .left-video {
        margin-bottom:10px;
    }

    .right-video {
        margin-top:15px;
    }


    @media (min-width: 768px) {
        .yt-video-container {
            width: 1200px;
            margin-left: auto;
            margin-right: auto;
            margin-top: 40px;
            padding-bottom: 30px;
        }
    }



    /* TAILORED SECTION */

    

    .tailored-section {
        text-align: center;
        padding-bottom: 100px;
        background-color: #F4F1ED;
    }

    .tailored-header {
        font-size: 35px;
        color:black; 
        margin-bottom:4px; 
        text-align:center;
    }

    .tailored-text {
        font-size: 20px;
        text-align:center;
    }

    .image-container {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        align-items: center;
    }

    .image-box {
        width: calc(50% ); 
        position: relative;
        margin: 0 10px; 
    }

    .overlay {
        position: relative;
        margin-top:20px;
        /*top: 50%;*/
        left: 23%;
        width: 300px;
        text-align: center;
        color: white;
        padding: 10px;
        border: 3px solid #AFBDB2;
    }

    .img1-mod {
        object-fit: cover;
        width:100%;
        height:500px;
    }
    .img2-mod {
        object-fit: cover;
        width:100%;
        height:470px;
    }
    .img3-mod {
        object-fit: cover;
        width:100%;
        height:440px;
    }

    /* Video navigation section */

    .video-navigation {
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 20px;
        background: rgba(145, 113, 60, 0.452);
        padding: 40px;
        /*border-radius: 10px;*/
        width: 100%;
        font-family: "OPTIwtcGoudy";
    }

    .video-navigation a {
        color: #333;
        text-decoration: none;
        padding: 5px 10px;
        border-radius: 5px;
        transition: background-color 0.3s ease;
    }

    .video-nav-text {
        margin:auto; 
        color:white; 
        font-size: 18px;
    }

    /* Book now */

    .book-now-section {
    position: relative;
    width: 100%;
    }

    .book-now-image {
        width: 100%;
        height: 700px;
        display: block;
        background-size: cover;
        background-image: url(../assets/images/katarina1.jpg);
        background-position: center;
    }
    .book-now-image::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.2);
    }
    .book-now-content {
        position: absolute;
        top: 0px;
        left: 0px;
        color: black;
    }

    .book-now-content h1 {
        font-size: 2em;
        margin-bottom: 20px;
        padding: 50px;
    }

    .book-now-button {
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 150px;
        margin-bottom: 50px !important;
        display: inline-block;
        padding: 10px 20px;
        background-color: transparent;
        color: black !important;
        text-decoration: none;
        border: 2px solid black;
        border-radius: 5px;
        font-weight: bold;
        transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
        font-size: 40px;
    }
    .book-now-button:hover {
        background-color: rgba(0, 0, 0, 0.329);
        color: white !important;
    }
    @media (min-width: 1000px) {
        .tailored-for-you {
            text-align: left;
            margin-left: 70px;
            font-size: 41px !important;
        }
        .overlay {
            padding: 30px;
            width: 450px;
        }
        .video-text-color {
            font-size: 41px;
        }
        .dimensions-luxury {
            font-size: 41px !important;
        }

    }

    @media (min-width: 1600px) {
        .tailored-for-you {
            margin-left: 150px;
        }
    }

    @media (max-width: 1000px) {
        .video-text {
            font-size: 19px;
        }
        .tailored-for-you {
            font-size: 40px !important;
        }
    }
    

    @media (max-width: 768px) {
        .video-text {
            background-color: rgba(139, 138, 138, 0.384);
            padding: 30px;
            width: 270px;
            text-align: center;
        }
        .phone-text-billiard {
            color: black !important;
        }
        .author-name {
            text-align: center !important;
        }
        .video-container {
            margin: 0px;
        }
        .video-text-color {
            font-size: 25px !important;
        }
        /*.video-text-position-left {
            background-color: transparent !important;
            margin-bottom: 0px;
            font-size:25px;
        }*/
        .text-color {
            color: black !important;
        }
        .overlay {
            margin: auto;
            margin-bottom:20px;
            left: 0%;
        }
        .image-box {
            width: 95%;
            /*width: 93% !important;*/
        }
        
        .img-box-right {
            width: 100%;
        }
        .image-container {
            display:block;
        }
        .img1-mod {
            height:350px;
            margin-bottom:20px;
        }
        .img2-mod {
            height:350px;
            margin-bottom:20px;
        }
        .img3-mod {
            height:350px;
            padding-right: 33px;
            padding-left: 13px;
        }
        .video-text-bottom-left {
            padding: 45px !important;
        }
        .video-text-top-right {
            padding: 45px !important;
            padding-left: 20px !important;
        }
        .videonav-text {
            text-align: center !important;
        }
        .content-with-border {
            width:100%;
        }
        .content-margin {
            margin-bottom: 20px;
        }
        .section-title {
            margin-left: 25px;
            margin-top: 20px;
            font-size: 30px !important;
        }
        .section-title-yt {
            font-size: 30px !important;
        }
        .dimensions-luxury {
            font-size: 32px !important;
        }
        .split-image-section {
            flex-direction: column; 
        }
        .left-half
        {
            display: flex;
            flex-direction: column-reverse;
            width: 100%; 
            padding: 25px;
        }
        .right-half {
            width: 100%; 
            padding: 25px;
        }

        .video-container {
            position: relative;
            overflow: hidden;
        }

        .fullscreen-video {
            width: 100%;
            height: 100vh;
            object-fit: cover;
            filter: brightness(60%);
        }

        .video-navigation {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-wrap: wrap; 
            justify-content: center; 
            gap: 10px; 
            background: rgba(145, 113, 60, 0.452);
            padding: 10px;
            border-radius: 0px;
            width: 100%; 
            margin: 0 auto; 
        }

        .video-navigation a {
            flex: 1; 
            text-align: center; 
            color: white;
            text-decoration: none;
            padding: 8px 0; 
        }

        .video-nav-text {
            margin-bottom:10px;
        }

        .nav-video-text-top-right {
            margin-top: 100px !important;
            padding: 20px !important;
        }

        .book-now-button {
            position: absolute;
            bottom: 0;
            right: 0;
            margin: 50px; 
            text-align: center;
            font-size: 33px !important;
        }
        .book-now-image {
            width: 100%;
            height: 500px;
            display: block;
            background-size: cover;
            background-image: url(/img/katarina1.05d3f927.jpg);
        }
        .yt-video-container {
            position: relative;
            width: 100%;
            padding-bottom: 56.25%;
            margin-top: 30px;
            margin-bottom: 25px;
        }

        .yt-video-container iframe {
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }
    
    
@media (min-width: 768px) {
    .flex-wrapper {
        flex-direction: row;
    }
    .flex-wrapper .row-item {
        margin-right: 12px !important;
    }
    .flex-wrapper .col-item {
        margin: 0;
    }
    #module-three .flex-wrapper .col-item {
        margin-bottom: 12px;
    }
    .scroll-more-overlay {
        height: 130px;
    }

    .text-box-right h4, .text-box-left h4 {
        color: rgb(0, 0, 0);
    }
    .spacer-xl {
        height: 140px;
    }
    .wide-img-module {
        height: auto;
        width: 100%;
    }
    .img-wrapper.left {
        margin-left: -1rem;
    }
    .img-wrapper.right {
        margin-right: -1rem;
    }
    .background-half-wrapper {
        margin-top: 3rem;
    }
    .maps-iframe {
        height: 600px;
    }
}
@media (max-width: 768px) {
    .jumbo-header .ds-image-overlay .matrix-element .matrix-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 500ms ease-out;
    }
    .module-wrapper {
        padding: 2rem!important;
    }
    #module-one.module-wrapper {
        padding-right: 0;
        padding-left: 0;
    }
    .flex-wrapper {
        padding: 0!important;
        flex-direction: column;
    }
    .mobile-flex-wrapper-reverse.flex-wrapper {
        flex-direction: column-reverse;
    }
    .flex-wrapper .row-item {
        margin: 0;
    }
    .flex-wrapper .col-item {
        margin-bottom: 12px !important;
    }
    .col-item.f-item-50 {
        flex: 100%;
    }
    .scroll-more-overlay {
        height: 125px;
        bottom: 50px !important;
    }
    .scroll-more-overlay{
        width: 30px;
        height: 60px;
    }
    .ds-card img {
        height: 300px;
        width: auto;
    }
    .alt-line-wrapper {
        display: none;
    }
    .v-overflow {
        margin: 0 .8rem;
    }
    .h-overflow-768 {
        overflow: hidden;
    }
    .text-box-left {
        padding: 20px 30px 40px;
    }
    .text-box-right {
        padding: 40px 30px 20px;
    }
    .spacer-xl {
        height: 110px;
    }
    .wide-img-module {
        height: 320px;
        width: auto;
    }
    .img-wrapper.left {
        margin-top: 1rem;
    }
    .img-wrapper.right {
        margin-bottom: 1rem;
    }
    .background-half-wrapper {
        margin-top: 0;
    }
    .copyright-section span {
        position: relative!important;
        display: block!important;
        width: 100%;
        text-align: right;
        padding-right: 12px;
        padding-bottom: 5px;
    }
    .text-block {
        padding: 0 0.8rem;
    }
    .maps-iframe {
        height: 500px;
    }
}
@media (min-width: 576px) {
    .info-section ul li {
        width: 38px;
        height: 38px;
        margin-right: 50px;
    }
    .info-section {
        padding: 2rem 1.5rem;
    }
}
@media (max-width: 576px) {
    #module-one .img-wrapper img {
        height: 350px;
        width: auto;
    }
    .jumbo-header .ds-image-overlay .matrix-element {
        padding: 150px 30px 200px;
    }
    .jumbo-header .ds-image-overlay .matrix-element .matrix-inner{
        padding-top: 100px!important;
    }
    .img-wrapper img {
        height: 350px;
        width: auto;
    }
    .spacer-xl {
        height: 30px;
    }
    .wide-img-module {
        height: 225px;
        width: auto;
    }
    .text-box-left {
        padding: 10px 15px 30px;
    }
    .text-box-right {
        padding: 30px 15px 10px;
    }
    .text-box-left .spacer-mm, .text-box-right .spacer-mm {
        height: 20px;
    }
    .info-section ul li {
        width: 22px;
        height: 22px;
        margin-right: 25px;
    }
    .info-section {
        padding: 1rem;
    }
    .overlay-text.acc-custom {
        padding: 5% 0 0 25px;
    }
    .overlay-text.acc-custom .spacer-sm {
        height: 5px;
    }
    .ds-card img.ds-card-blur {
        height: 230px;
    }
}
@media (min-width: 496px) {
    .matrix-inner .slogan-wrapper h1.subtitle {
        font-size: 35px!important;
    }
}
@media (max-width: 496px) {
    .wide-img-module {
        height: 200px;
        width: auto;
    }
    .text-box-left {
        padding: 10px 15px 15px;
    }
    .text-box-right {
        padding: 15px 15px 10px;
    }
    .text-box-left .spacer-mm, .text-box-right .spacer-mm {
        height: 10px;
    }
    .matrix-inner .slogan-wrapper h1.subtitle {
        font-size: 25px!important;
    }
    .module-wrapper.mobile-wrapper-none {
        padding-left: 0!important;
        padding-right: 0!important;
    }
    .ds-card-overlay .ds-title-box {
        justify-content: center;
    }
    .ds-card img.ds-card-blur {
        height: 190px;
        width: 500px;
    }
}
@media (max-width: 415px) {
    .info-section h3 {
        font-size: 22px!important;
    }
    #accommodation .jumbo-header .ds-image-overlay .matrix-element {
        padding-left: 0!important;
        padding-right: 0!important;
    }
}
@media (max-width: 400px) {
    .overlay-text {
        padding: 5% 0 0 25px;
    }
    .overlay-text.acc-custom h3 {
        font-size: 28px!important;
    }
}
@media (min-height: 685px) {
    .matrix-inner {
        padding-top: 200px;
    }
}
@media (max-height: 685px) {
    .matrix-inner {
        padding-top: 100px;
    }
}
@media (max-height: 567px) {
    .matrix-inner {
        padding-top: 50px;
    }
}

.dark-overlay {
    background-color: rgba(0, 0, 0, .3912);
}
.light-overlay {
    background-color: rgba(58, 57, 57, .4);
}
.dim-overlay {
    background-color: rgba(0, 0, 0, .2512);
}
.overlay-text {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: #ffffff;
    text-align: left;
}
.light-overlay a {
    color: #ffffff;
}
.svg-bg-m {
    background-color: #9fa4c4;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%239e768f'/%3E%3Cstop offset='1' stop-color='%239fa4c4'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%239f8daa'/%3E%3Cstop offset='1' stop-color='%239fa4c4'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg transform='translate(640 0)'%3E%3Cg %3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform='rotate(-129.6 0 0)'%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.3' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
}
#home .jumbo-header, #contact-us .jumbo-header {
    /*background-image: url('../assets/video/IMG_2036.mp4');*/
}
#home {
    background-color: rgb(239, 235, 229) !important;
}
.jumbo-header {
  width: 100%;
  height: 100vh;
  overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: all 4500s ease-out;
}
.jumbo-header .ds-image-overlay {
    justify-content: flex-start;
}
.jumbo-header .ds-image-overlay .matrix-element {
    perspective: 40px;
    width: 100%;
    height: 100%;
}
.jumbo-header .ds-image-overlay .matrix-element .matrix-inner {
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 500ms ease-out;
}
.matrix-inner {
    width: 100%;
    height: 100%;
    transition: transform 500ms ease-out;
}
.module-wrapper {
    width: 100%;
    padding: 3rem;
}
.col-display {
  display: inline-block;
}
.spacer-sm {
  height: 20px;
}
.spacer-mm {
  height: 40px;
}
.spacer-lg {
  height: 60px;
}
.img-res {
  width: 100%;
  height: auto;
}
.module-eight-bg {
  width: 100%;
  height: 650px;
  background-image: url("../assets/photos/Katarina_outside_5.jpg");
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.scroll-more-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
    padding-bottom: 20px;
  text-align: center;
}
.scroll-more-overlay p {
  color: #f7f7f7;
}
.before-enter {
  opacity: 0;
  transform: translateY(180px);
  transition: all 800ms ease-out;
}
.enter {
  opacity: 1;
  transform: translateY(0px);
  transition-delay: 500ms;
}
.purple-light {
    background-color: rgba(182, 169, 235, 0.4);
}
.yellow-light {
    background-color: rgba(117, 106, 85, 0.4);
}
.jumbo {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 0;
}
.jumbo-inner {
    width: inherit;
    height: inherit;
    position: relative;
}
/*
.icon-scroll {
    width: 40px;
    height: 70px;
    box-shadow: inset 0 0 0 1px #fff;
    border-radius: 25px;
    margin: 0 auto 12px auto;
}
.icon-scroll:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background: #fff;
    margin-left: -4px;
    top: 8px;
    border-radius: 4px;
    animation-delay: 2s;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-name: scroll;
}
@keyframes scroll {
    0% {opacity: 1}
    100% {opacity: 0; transform: translateY(46px);}
}*/
.house-title {
    font-family: "YAFdJnPX3ZE 0", _fb_, auto;
    font-size: 45px;
    letter-spacing: 0.3em;
}
.img-filter-dark-shadow {
    filter: drop-shadow(10px 10px 20px rgba(0, 0, 0, 0.35));
}
h1 span.s-base-start {
    font-family: "OPTIwtcGoudy";
    display: block;
    letter-spacing: 15px;
}
h1 span.s-base-start-last-words {
    font-family: "OPTIwtcGoudy";
    display: inline-block;
    margin-right: 20px;
    letter-spacing: 15px;
}
.s-base-start {
    transform: translateY(200px);
    opacity: 0;
    font-size: inherit;
}
h1 span.s-base, h1.s-base {
    animation-name: fly-up;
    animation-duration: 1000ms;
    animation-timing-function: ease;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: forwards;
    animation-play-state: running;
    white-space: pre-wrap;
}
.s1 {
    animation-delay: 300ms;
}
.s2 {
    animation-delay: 550ms;
}
.s3 {
    animation-delay: 700ms;
}
.s4 {
    animation-delay: 950ms;
}
.s5 {
    animation-delay: 1200ms;
}
@keyframes fly-up {
    from {transform: translateY(200px); opacity: 0}
    to {transform: translateY(0); opacity: 1}
}

@media (max-width: 768px) {
    .house-title {
        font-size: 20px;
    }
    h1 span.s-base-start {
        font-family: "OPTIwtcGoudy";
        display: block;
        font-size:25px !important;
        letter-spacing: 8px;
    }
    h1 span.s-base-start-last-words {
        font-family: "OPTIwtcGoudy";
        display: inline-block;
        font-size:25px !important;
        margin-right: 20px;
        letter-spacing: 8px;
    }
}



</style>
